import * as React from "react";

import { IContextualMenuItem } from "@fluentui/react/lib/ContextualMenu";

import { dataUniqueId } from "@1js/acui-common";
import { AppIcons } from "@1js/acui-icons";
import { memoizeLastResultPerId } from "@1js/acui-memoization";

import { SimpleMenuItemControlProps } from "../MenuDefinition";
import { memoizedDismissMenu } from "../MenuDismiss";

export type RenderIContextualMenuItemCallback = (
  menuItem: IContextualMenuItem,
  dismissMenu: (ev?: any, dismissAll?: boolean) => void
) => React.ReactNode;

export const getDefaultMemoizedMenuItem = memoizeLastResultPerId(
  (
    _id: string,
    controlProps: SimpleMenuItemControlProps,
    onRender: RenderIContextualMenuItemCallback,
    getCustomOnRenderListLength?: (prop: SimpleMenuItemControlProps) => number
  ): IContextualMenuItem => {
    return {
      key: controlProps.id,
      data: controlProps,
      onRender,
      customOnRenderListLength: getCustomOnRenderListLength
        ? getCustomOnRenderListLength(controlProps)
        : 1,
      "data-unique-id": dataUniqueId(controlProps),
    };
  }
);

export type GetReactComponentForControlInMenuFunction = (
  props: SimpleMenuItemControlProps,
  dismissMenu: () => void,
  itemIndex: number,
  totalSize: number,
  appIcons?: AppIcons
) => JSX.Element;

export function getDefaultMenuItem(
  controlProps: SimpleMenuItemControlProps,
  getReactComponentForControlInMenu: GetReactComponentForControlInMenuFunction,
  appIcons?: AppIcons,
  getCustomOnRenderListLength?: (prop: SimpleMenuItemControlProps) => number
): IContextualMenuItem {
  const onRender = (
    menuItem: IContextualMenuItem,
    dismissMenu: (ev?: any, dismissAll?: boolean) => void
  ) => (
    <div key={menuItem.key}>
      {getReactComponentForControlInMenu(
        menuItem.data,
        memoizedDismissMenu(dismissMenu),
        Number(menuItem["aria-posinset"]),
        Number(menuItem["aria-setsize"]),
        appIcons
      )}
    </div>
  );
  return getDefaultMemoizedMenuItem(
    controlProps.id,
    controlProps,
    onRender,
    getCustomOnRenderListLength
  );
}
